import React from 'react';
import PropTypes from 'prop-types';

const SFTPSettingsFrame = (props) => (
  <div>
    {props.children}
  </div>
);

SFTPSettingsFrame.propTypes = {
  children: PropTypes.node,
};

export default SFTPSettingsFrame;
